import { render, staticRenderFns } from "./PublicMusic.vue?vue&type=template&id=0ccba0be&"
import script from "./PublicMusic.vue?vue&type=script&lang=js&"
export * from "./PublicMusic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports